// import Rx from 'rxjs/Rx';

import {Reducer} from 'redux';
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {PledgerAction} from "@pledger/frontend-commons";
import {FooterType} from "../app/FooterType";


/**
 * Reducers de la page Home.
 *
 * Les donnée d'affichage de lapage Home sont fixes, ce qui explique
 * l'abscence d'epics de chargement spécifiques.
 *
 * @module front/reducers/HomeReducers
 */


const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};


export interface HomePageComponentState extends PledgerPageComponentState {

}

export const home : Reducer = (state={},action)=>{
    return{
        footerType: footerType(state.footerType, action)
    }
}
